import type { CoreOfficeDataType } from '~/types/offices';
import { currencyDisplay } from '~/components/utils/text';
import { getPriceAfterDiscounts, getPricePerSeat, lastMinuteDiscountApplied, longTermDiscountApplied } from './utils';
import type { DateTime } from 'luxon';
import PricePerSeatPopover from './PricePerSeatPopover';
import DiscountPopover from './DiscountPopover';

type TProps = {
  office: CoreOfficeDataType;
  daysPerWeek: number;
  requiredCapacity: number;
  startDate: DateTime | null;
  endDate: DateTime | null;
};

const PricePerSeatBreakdown = ({ office, requiredCapacity, daysPerWeek, startDate, endDate }: TProps) => {
  const longTermDiscountApplies = longTermDiscountApplied(office.discountLongTermMonths, startDate, endDate);
  const lastMinuteDiscountApplies = lastMinuteDiscountApplied(office.discountLastMinuteDays, startDate);

  const discountApplied = longTermDiscountApplies || lastMinuteDiscountApplies;

  const discountLongTermPercent = office.discountLongTermPercent || 0;
  const discountLastMinutePercent = office.discountLastMinutePercent || 0;

  const pricePerSeatAfterDiscounts = getPriceAfterDiscounts(
    getPricePerSeat(daysPerWeek, office, requiredCapacity),
    longTermDiscountApplies ? discountLongTermPercent : 0,
    lastMinuteDiscountApplies ? discountLastMinutePercent : 0,
  );

  return (
    <>
      <PricePerSeatPopover
        office={office}
        requiredCapacity={requiredCapacity}
        daysPerWeek={daysPerWeek}
        pricePerSeatAfterDiscounts={Math.round(pricePerSeatAfterDiscounts)}
      />
      <div className="d-flex justify-content-between align-items-center">
        {discountApplied && (
          <div>
            <span className="text-2 -regular color-grey-600 text-decoration-line-through me-1">
              {currencyDisplay(getPricePerSeat(daysPerWeek, office, requiredCapacity), 0)}
            </span>
            <span className="price-display"> {currencyDisplay(pricePerSeatAfterDiscounts, 0)}</span>
          </div>
        )}
        {!discountApplied && (
          <span className="price-display">
            {currencyDisplay(getPricePerSeat(daysPerWeek, office, requiredCapacity), 0)}{' '}
          </span>
        )}
        {(office.discountLastMinutePercent || office.discountLongTermPercent) && <DiscountPopover office={office} />}
      </div>
    </>
  );
};

export default PricePerSeatBreakdown;
